module.exports = __webpack_public_path__ + "static/stockperks-logo-1ecc1ed68d0d541458f67011fd84c821.png";